export default __webpack_public_path__ + "static/media/criteria_blue.ccac9218.png";